 <template lang="pug">
  #main-app
    transition(name="fade")
      router-view
</template>

<script>
  import i18n from "src/content"

  export default {
    i18n,
    name: "App",
  }
</script>

<style lang="sass" src="./styles/application.sass"></style>



// WEBPACK FOOTER //
// src/App.vue